<div class="checkbox-group-container" [class.horizontal]="horizontal">
  <div *ngFor="let option of options; let i = index">
    <p-checkbox
      [name]="groupName"
      [value]="option"
      [label]="option.name"
      [formControl]="formControl"
      [inputId]="i"
    ></p-checkbox>
  </div>
</div>
